// src/services/analysis.service.js
// Cliente del Análisis Ejecutivo. La llamada a Mistral la hace el servicio del
// chatbot (chatbot/servidor.js, POST /chat/analisis) con la MISTRAL_API_KEY de
// runtime: la misma key del chatbot, y nunca viaja al navegador. El prompt
// también vive en el servidor (chatbot/promptAnalisis.js).
// En producción nginx enruta /chat/ al servicio; en desarrollo lo hace el
// proxy de vue.config.js.
import { track } from "@/services/telemetry";

const ANALISIS_URL = process.env.VUE_APP_ANALISIS_URL || "/chat/analisis";

/**
 * Solicita el análisis ejecutivo CX de una encuesta.
 * @param {object} encuesta  JSON del dashboard/ejecución (incluye respuestas)
 * @returns {Promise<string>}  Texto en Markdown
 */
export async function analizarEncuesta(encuesta) {
  // Por encima del timeout del servidor (150 s), para que gane su mensaje de error.
  const r = await fetch(ANALISIS_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ encuesta }),
    signal: AbortSignal.timeout(170000),
  });
  let data = null;
  try {
    data = await r.json();
  } catch (e) {
    data = null;
  }
  if (!r.ok) {
    // Sin cuerpo JSON = respondió el proxy (nginx o el dev server), no el servicio.
    throw new Error(
      (data && data.error) ||
        "El servicio de análisis no está disponible (" + r.status + "). Intenta más tarde."
    );
  }

  const texto = (data && data.analisis) || "";
  track("reporte_generado", {
    tipo: "analisis_ejecutivo",
    modelo: data && data.modelo,
    vacio: !texto,
  });
  return texto;
}
